import {HashDetailDto} from '../../../models/dtos/hashDetail.dto';
import axios from '../../../utilities/axios';

export const getHashRequest = async (hash: string): Promise<HashDetailDto> => {
  try {
    const response = await axios.get<HashDetailDto>(
      `${process.env.REACT_APP_BASE_URL}/tickets?hash=${hash}`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
